import { Typography, Stack } from '@optimus-web/core';
import { OrderItem } from '@mews-commander/types';
import { ConvertedCurrencyValue, LocalizedShortDateFromUtc } from '@mews-commander/ui';
import { Table } from '@mews-commander/ui/legacy';
import { additionalExpensesHandler } from '../../additionalExpensesHandler';

interface Props {
    additionalExpenses: OrderItem[];
    serviceId: string;
    isMultiTaxEnvironment: boolean;
}

const AdditionalExpensesItemsList = ({ additionalExpenses, serviceId, isMultiTaxEnvironment }: Props) => {
    const mapping = [
        {
            valueKey: 'type',
            render: ({ data, startUtc }: OrderItem) => (
                <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                    <Stack spacing="100" inline>
                        {additionalExpensesHandler(data.discriminator, { serviceId })}
                        {startUtc !== null && <LocalizedShortDateFromUtc utcString={startUtc} />}
                    </Stack>
                </Typography>
            ),
        },
        {
            valueKey: 'amount',
            render: ({ totalAmount }: OrderItem) => (
                <ConvertedCurrencyValue amount={totalAmount} net={isMultiTaxEnvironment} />
            ),
            columnAlignment: 'right',
        },
    ];

    return <Table mapping={mapping} source={additionalExpenses} headerless />;
};

export default AdditionalExpensesItemsList;
